import { render, staticRenderFns } from "./WideCard.vue?vue&type=template&id=19a14471&scoped=true"
import script from "./WideCard.vue?vue&type=script&lang=js"
export * from "./WideCard.vue?vue&type=script&lang=js"
import style0 from "./WideCard.vue?vue&type=style&index=0&id=19a14471&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19a14471",
  null
  
)

export default component.exports